module.exports = __webpack_public_path__ + "static/vf-button-pants.3b9f5989.svg";